module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAdminRole) ? _c('div', {
    staticClass: "permissions-category-upsert"
  }, [_c('permissions-table')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-680c72da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/permissions/PermissionsView.vue
// module id = 1918
// module chunks = 0